import { get } from './token'
import { get as getRequest } from './request'
import store from '../store/index'
/**
 * @param {} user
 * 验证用户权限
 */
export const getUserPower = async (user) => {
  /* eslint-disable */
  if (!user) {
    user = get('user')
  }
  if (!user) return
  const res = await getRequest({
    url: `/user/getRouterModuleAuth/${user.phoneNumber}`
  })
  const {
    data: {
      message,
      detail: {
        modularAuth: {
          tabbar,
          center,
          home,
          dynamic,
          calendar
        },
        routerAuth
      }
    }
  } = res
  const value = JSON.parse(localStorage.getItem('router'))
  if (Object.is(message, 'ok')) {
    store.dispatch('router/updateRouter', routerAuth)
    store.dispatch('tarbarAuth/updateAuth', tabbar)
    store.dispatch('centerAuth/updateAuth', center)
    store.dispatch('homeAuth/updateAuth', home)
    store.dispatch('dynamicAuth/updateAuth', dynamic)
    store.dispatch('calendarAuth/updateAuth', calendar)
  }
  if (value) {
    const { value: oldRouter } = value
    const newRouters = store.getters['router/getRouter']
    if (oldRouter.exerlandRouter.length !== newRouters.exerlandRouter.length || oldRouter.tabbarRouter.length !== newRouters.tabbarRouter.length) {
      window.location.reload()
    }
  }
  return true
}

export const goHomePath = () => {
  const power = store.getters['tarbarAuth/getAuth']
  let path = 'find'
  if (power.home) {
    path = 'find'
  } else if (power.dynamic) {
    path = 'dynamic'
  } else if (power.refining) {
    path = 'refining'
  } else if (power.center) {
    path = 'center'
  } else if (power.groupsList) {
    path = 'groupsList'
  } else {
    path = 'find'
  }
  return `/exerland/bbs/${path}`
}
